document.addEventListener('DOMContentLoaded', () => {
    if (getCookie('tutorial_completed')) {
        return;
    }

    const tutorial = document.getElementById('shop-all-tutorial');

    if (!tutorial || tutorial.dataset.showTutorial !== '1') {
        return;
    }

    const steps = [
        {
            element: '#filter-button',
            text: tutorial.dataset?.stepOneText ?? 'Click here to open the filters.',
        },
        {
            element: '#skin-needs-label',
            text: tutorial.dataset?.stepTwoText ?? 'Now, click on "Skin needs" to expand the options.',
        },
        {
            element: '#skin-needs-list',
            text: tutorial.dataset?.stepThreeText ?? 'Finally, select a value from this dropdown.',
        },
    ];

    let currentStep = 0;

    document.body.style.overflow = 'hidden';
    const overlay = tutorial.querySelector('#overlay');
    const tooltip = tutorial.querySelector('#tooltip');

    const showStep = (stepIndex) => {
        const step = steps[stepIndex];
        const target = document.querySelector(step.element);

        if (!target) {
            console.error(`Element not found for step ${stepIndex + 1}: ${step.element}`);

            return;
        }

        target.classList.add('tutorial-highlight');

        overlay.style.display = 'block';

        if (stepIndex > 0) {
            setTimeout(() => {
                positionTooltip(target, step.text, stepIndex);
            }, 100);
        } else {
            positionTooltip(target, step.text, stepIndex);
        }

        const clickHandler = () => {
            target.classList.remove('tutorial-highlight');
            tooltip.style.display = 'none';

            // prevent skin-needs-list from hiding on click away
            if (stepIndex === 1) {
                tooltip.addEventListener('click', stopPropagation);
                overlay.addEventListener('click', stopPropagation);
            }

            if (currentStep < steps.length - 1) {
                currentStep++;
                showStep(currentStep);
            } else {
                document.body.style.overflow = 'auto';
                overlay.style.display = 'none';
                tooltip.remove();

                document.cookie = "tutorial_completed=true; path=/; max-age=" + 60 * 60 * 24 * 180; // 180 days
            }

            target.removeEventListener('click', clickHandler);
        };

        target.addEventListener('click', clickHandler);
    };

    showStep(currentStep);

    function positionTooltip(target, text, stepIndex) {
        const rect = target.getBoundingClientRect();
        const windowWidth = window.innerWidth;

        if (stepIndex === 0 && windowWidth >= 1024) {
            tooltip.style.left = `${(rect.width - rect.left) / 2}px`;
        } else if (windowWidth >= 1024) {
            tooltip.style.left = `${(rect.left + rect.width) / 2}px`;
        } else {
            tooltip.style.left = '20px';
        }

        tooltip.style.top = `${rect.bottom + 15}px`;
        tooltip.innerHTML = text;
        tooltip.style.display = 'block';
    }

    function stopPropagation(event) {
        event.stopPropagation();
    }
});

const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) return parts.pop().split(';').shift();

    return null;
};